import { useLocation } from "react-router-dom"

export const useIsEdit = (itemId: string) => {
  const location = useLocation()
  const isEdit = Boolean(itemId) && location.pathname.includes("edit")
  const navigatePath = isEdit ? "../.." : ".."

  return { isEdit, navigatePath }
}
